import React from "react";
import { LocalServiceTemplate } from "@/components/local/LocalServiceTemplate";
import { localServiceData } from "@/data/localServiceData";

const AircoWestervoort = () => {
  return <LocalServiceTemplate data={localServiceData['airco-westervoort']} />;
};

export default AircoWestervoort;